export default [
    {
        path: "/budgeting-and-app/view-app",
        name: "view-app",
        meta: {
            title: "annual procurement plans",
            authRequired: true,
          /*  privileges: [
                'ROLE_PRIVILEGE_HERE',
            ]*/
        },
        component: () => import("../views/budgeting-and-app/view-app.vue"),
    },
    {
        path: "/budgeting-and-app/add-new-app",
        name: "add-new-app",
        meta: {
            title: "new annual procurement plan",
            authRequired: true,
            /*  privileges: [
                  'ROLE_PRIVILEGE_HERE',
              ]*/
        },
        component: () => import("../views/budgeting-and-app/add-new-app.vue"),
    },
    {
        path: "/budgeting-and-app/app-import",
        name: "app-imports",
        meta: {
            title: "annual procurement plans imports",
            authRequired: true,
            /*  privileges: [
                  'ROLE_PRIVILEGE_HERE',
              ]*/
        },
        component: () => import("../views/budgeting-and-app/app-uploads.vue"),
    },
    {
        path: "/budgeting-and-app/create-app",
        name: "create-app",
        meta: {
            title: "create APP",
            authRequired: true,
            /*  privileges: [
                  'ROLE_PRIVILEGE_HERE',
              ]*/
        },
        //component: () => import("../views/budgeting-and-app/create-app.vue"),
    },
    {
        path: "/budgeting-and-app/submitted-app",
        name: "submitted-app",
        meta: {
            title: "Submitted APP",
            authRequired: true,
            /*  privileges: [
                  'ROLE_PRIVILEGE_HERE',
              ]*/
        },
        component: () => import("../views/budgeting-and-app/submitted-app.vue"),
    },
    {
        path: "/budgeting-and-app/approve-app",
        name: "approve-app",
        meta: {
            title: "Approve APP",
            authRequired: true,
            /*  privileges: [
                  'ROLE_PRIVILEGE_HERE',
              ]*/
        },
        component: () => import("../views/budgeting-and-app/approve-app.vue"),
    },
    {
        path: "/budgeting-and-app/previous-app-versions",
        name: "previous-app-versions",
        meta: {
            title: "Previous App Version",
            authRequired: true,
            /*  privileges: [
                  'ROLE_PRIVILEGE_HERE',
              ]*/
        },
        component: () => import("../views/budgeting-and-app/previous-app-versions.vue"),
    },
    {
        path: "/budgeting-and-app/approved-app",
        name: "approved-app",
        meta: {
            title: "Approved APP",
            authRequired: true,
            /*  privileges: [
                  'ROLE_PRIVILEGE_HERE',
              ]*/
        },
        component: () => import("../views/budgeting-and-app/approved-apps.vue"),
    },
]